import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62afa86a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "services-offer py-5" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "My Freelance Services", -1))
const _hoisted_4 = { class: "columns is-multiline" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-content" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "subtitle" }
const _hoisted_9 = { class: "price" }
const _hoisted_10 = { class: "features" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "column is-half",
            "data-aos": "fade-up",
            key: service.title
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(service.title), 1),
                _createElementVNode("p", _hoisted_8, _toDisplayString(service.description), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(service.price), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(service.features, (feature) => {
                      return (_openBlock(), _createElementBlock("li", { key: feature }, _toDisplayString(feature), 1))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}